import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { CustomLoader } from "../../shared/components/others";
import { toast } from "react-toastify";

const PaymentCancelled = () => {
  const navigate = useNavigate();

  useEffect(() => {
    toast.error("Le paiement a été annulé");
    const timeout = setTimeout(() => {
      navigate("/dashboard");
    }, 1000);

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"50vh"}
    >
      <CustomLoader />
    </Box>
  );
};

export default PaymentCancelled;